import PropTypes from 'prop-types';
import React, { Component } from 'react';
import AsyncSelect from 'react-select/lib/Async';
import { getFullName, displayError } from '../utilities';
import { fetchPatientDetails } from '../queries';
export default class PatientSearchByPhone extends Component {
  state = {};
  fetchPatient = async mobileRaw => {
    const mobile = `${mobileRaw}`.trim().slice(0, 10);
    if (mobile.length < 10) return;
    try {
      const res = await fetchPatientDetails({ mobile });
      const patients = res.data.getPatientDetails || [];
      const list = patients
        .filter(r => !r.isDeleted)
        .map(r => ({
          label: getFullName(r.first_name, r.last_name) + ' - ' + r.mpid,
          value: r
        }));

      list.push({
        label: 'Create New Patient',
        value: { isNew: true, mobile }
      });
      return list;
    } catch (err) {
      displayError(
        err.response.data
          ? err.response.data.error.message
          : 'Something went wrong!'
      );
    }
  };

  handleInputChange = (inputRaw, { action }) => {
    // console.log('slot inp ' + input + ', act ' + JSON.stringify(action));
    const input = `${inputRaw}`.trim().replace(/\D/, '');
    if (input && input.length > 10) {
      this.setState({ value: input.slice(0, 10) });
    } else {
      this.setState({ value: input });
    }
    // TODO: figure out why it does not render input if next line
    // placed at the top of the function
    if (action !== 'input-change') return;
    this.props.onInputChange(input);
  };

  render() {
    const { onChange } = this.props;
    return (
      <AsyncSelect
        cacheOptions
        inputValue={this.state.value}
        loadOptions={mobile => this.fetchPatient(mobile)}
        onChange={opt => onChange(opt.value)}
        onInputChange={this.handleInputChange}
        maxMenuHeight={200}
      />
    );
  }
}

PatientSearchByPhone.propTypes = {
  onChange: PropTypes.func,
  onInputChange: PropTypes.func,
  hospitalId: PropTypes.number
};
